import { useEffect, useMemo } from 'react';

import SubscriptionSelectionOptions from '../SubscriptionSelectionOptions';
import SubscriptionSelectionStarterKit from '../SubscriptionSelectionStarterKit';
import InfoButton from '../../../../../global/InfoButton';
import { filterEnabledItems } from '../../../../../utils/utils';
import { SUBSCRIPTION_PAYMENT_TYPES } from '../../../../../utils/subscriptions';

import './SubscriptionSelectionSections.scss';

export const SUBSCRIPTION_SELECTION_SECTIONS = {
  STARTER_KIT: 'starter-kit',
  OPTIONS: 'options',
};

const SubscriptionSelectionSections = ({
  sections = [],
  optionSelected,
  onOptionSelect,
  onContinue,
}) => {
  const sectionsForDisplay = useMemo(() => sections.map((section) => {
    if (section.id !== SUBSCRIPTION_SELECTION_SECTIONS.OPTIONS) {
      return section;
    }

    return {
      ...section,
      items: filterEnabledItems(section.items).filter(
        (item) => item.type !== SUBSCRIPTION_PAYMENT_TYPES.ONE_TIME,
      ),
    };
  }), [sections]);

  useEffect(() => {
    if (sectionsForDisplay?.length === 0) {
      return;
    }

    const optionsSection = sectionsForDisplay.find(
      (section) => section.id === SUBSCRIPTION_SELECTION_SECTIONS.OPTIONS,
    );

    const firstOption = optionsSection?.items?.[0];

    if (firstOption) {
      onOptionSelect(firstOption.uid, firstOption.type);
    }
  }, [sectionsForDisplay, onOptionSelect]);

  if (sectionsForDisplay?.length === 0) {
    return null;
  }

  return (
    <div className="SubscriptionSelectionSections">
      {sectionsForDisplay?.map((section) => (
        <div key={section.id} className="SubscriptionSelectionSections__section">
          {section.id !== SUBSCRIPTION_SELECTION_SECTIONS.OPTIONS && (
            <div className="SubscriptionSelectionSections__section-title">
              <span className="SubscriptionSelectionSections__section-title-text">
                {section.title}
              </span>
              {section?.info && (
                <InfoButton info={section.info} />
              )}
            </div>
          )}
          <div className="SubscriptionSelectionSections__section-content">
            {section.id === SUBSCRIPTION_SELECTION_SECTIONS.STARTER_KIT && (
              <SubscriptionSelectionStarterKit />
            )}
            {section.id === SUBSCRIPTION_SELECTION_SECTIONS.OPTIONS && (
              <SubscriptionSelectionOptions
                section={section}
                selected={optionSelected}
                onSelect={onOptionSelect}
                onContinue={onContinue}
              />
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SubscriptionSelectionSections;
